module.exports = __webpack_public_path__ + "static/img/061日式料理菜单.39218f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/061日式料理菜单.jpg
// module id = rNKl
// module chunks = 0